import React, { useRef } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import Illustration from '@adsk/alloy-react-illustration';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';

import DropZone from './DropZone';
import UploadItem from './UploadItem';

const StyledIllustration = styled(Illustration)`
  padding: 12px;
`;

const Text = styled.p(theme.typography.heading3);

const Link = styled.a`
  line-height: 20px;
  font-weight: 450;
  font-style: normal;
  color: ${theme.colors.adskBlue700};
  &:hover {
    cursor: pointer;
  }
`;

const UploadList = styled.div`
  width: 100%;
  height: 100%;
`;

const DocsUploadBody = React.forwardRef(
  ({ files, onUpload, onRemove }, ref) => {
    const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
    const fileInputEl = useRef(null);

    const handleSelectButtonClick = (e) => {
      e.currentTarget.blur();
      fileInputEl.current && fileInputEl.current.click();
    };

    const handleUpload = (e) => {
      e.stopPropagation();
      const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
      onUpload(files);
      e.target.value = '';
    };

    return (
      <>
        <DropZone ref={ref} onDrop={onUpload}>
          {files.length > 0 ? (
            <UploadList>
              {files.map((file) => (
                <UploadItem key={file.id} file={file} onRemove={onRemove} />
              ))}
            </UploadList>
          ) : (
            <div>
              <StyledIllustration
                type={Illustration.TYPES.FOLDER_PHOTO_CLOSED_FIST_GREY}
              />
              <Text>{T.translate('DRAG_FILE_HERE_OR')}</Text>
              <Link onClick={handleSelectButtonClick}>
                {T.translate('CHOOSE_FILE')}
              </Link>
            </div>
          )}
        </DropZone>
        <input
          ref={fileInputEl}
          style={{ visibility: 'hidden' }}
          type="file"
          multiple
          onChange={handleUpload}
        />
      </>
    );
  },
);

DocsUploadBody.displayName = 'MediaUploadBody';
DocsUploadBody.propTypes = {
  files: PropTypes.array.isRequired,
  onUpload: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default DocsUploadBody;
